"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsWrapper";
import { VolumeType } from "@/entities/INFT";
import { faCheck, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
const VOLUME_TYPES = Object.values(VolumeType);
export default function VolumeTypeDropdown(t0) {
  const $ = _c(27);
  const {
    isVolumeSort,
    selectedVolumeSort,
    setVolumeType,
    setVolumeSort
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const buttonRef = useRef(null);
  let t1;
  if ($[0] !== isVolumeSort || $[1] !== setVolumeSort || $[2] !== setVolumeType) {
    t1 = volumeType => {
      setVolumeType(volumeType);
      if (!isVolumeSort) {
        setVolumeSort();
      }
      setIsOpen(false);
    };
    $[0] = isVolumeSort;
    $[1] = setVolumeSort;
    $[2] = setVolumeType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSelect = t1;
  const t2 = `Volume: ${selectedVolumeSort}`;
  let t3;
  if ($[4] !== isOpen) {
    t3 = () => setIsOpen(!isOpen);
    $[4] = isOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `tw-relative tw-m-0 tw-inline-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-1 tw-whitespace-nowrap tw-border-0 tw-bg-transparent tw-px-0.5 tw-py-1 tw-text-sm tw-font-medium tw-leading-5 tw-no-underline tw-transition-colors tw-duration-200 after:tw-absolute after:-tw-bottom-0.5 after:tw-left-0 after:tw-h-px after:tw-w-full after:tw-origin-left after:tw-transition-transform after:tw-duration-200 after:tw-content-[''] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-primary-400 sm:tw-shrink ${isVolumeSort ? "tw-text-white after:tw-scale-x-100 after:tw-bg-primary-400" : "tw-text-iron-500 after:tw-scale-x-0 after:tw-bg-iron-700 hover:tw-text-iron-200 hover:after:tw-scale-x-100"}`;
  const t5 = isVolumeSort ? ` (${selectedVolumeSort})` : "";
  let t6;
  if ($[6] !== t5) {
    t6 = <span>Volume{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = `tw-h-3 tw-w-3 tw-transition-transform tw-duration-200 ${isOpen ? "tw-rotate-180" : ""}`;
  let t8;
  if ($[8] !== t7) {
    t8 = <FontAwesomeIcon icon={faChevronDown} className={t7} aria-hidden="true" />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== isOpen || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t6 || $[15] !== t8) {
    t9 = <button ref={buttonRef} type="button" aria-haspopup="true" aria-expanded={isOpen} aria-label={t2} onClick={t3} className={t4}>{t6}{t8}</button>;
    $[10] = isOpen;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== handleSelect || $[18] !== isMobile || $[19] !== selectedVolumeSort) {
    t10 = VOLUME_TYPES.map(volumeType_0 => {
      const isActive = selectedVolumeSort === volumeType_0;
      return <li key={`volume-${volumeType_0}`} className="tw-h-full tw-min-w-0" role="none"><button type="button" data-testid="item" role="menuitem" onClick={() => handleSelect(volumeType_0)} className={`${isMobile ? "tw-px-4 tw-py-3" : "tw-px-3 tw-py-2"} tw-box-border tw-flex tw-w-full tw-max-w-full tw-items-center tw-justify-between tw-gap-x-2 tw-overflow-hidden tw-rounded-md tw-border-0 tw-bg-transparent tw-text-left tw-text-sm tw-font-medium tw-text-iron-200 tw-transition tw-duration-200 tw-ease-out hover:tw-bg-iron-800 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 ${isActive ? "tw-bg-iron-800 tw-text-iron-100" : ""}`}><span className="tw-min-w-0 tw-flex-1 tw-truncate">{volumeType_0}</span>{isActive && <FontAwesomeIcon icon={faCheck} className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-text-primary-300" aria-hidden="true" />}</button></li>;
    });
    $[17] = handleSelect;
    $[18] = isMobile;
    $[19] = selectedVolumeSort;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== isOpen || $[22] !== t10) {
    t11 = <CommonDropdownItemsWrapper isOpen={isOpen} filterLabel="Volume" buttonRef={buttonRef} horizontalAlign="right" portalClassName="tailwind-scope tw-z-[999]" setOpen={setIsOpen} onIsMobile={setIsMobile}>{t10}</CommonDropdownItemsWrapper>;
    $[21] = isOpen;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = <div data-testid="dropdown" className="tailwind-scope tw-relative tw-inline-flex tw-shrink-0">{t9}{t11}</div>;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}